module.exports = __webpack_public_path__ + "media/application-logos/prospect-horizontal-navy-3af415d9.svg";